import { useRouteMatch } from 'react-router-dom'

import { useAppSelector } from 'common/hooks/redux'

import { Campaigns } from './components/Campaigns'
import DashboardHeader from './components/DashboardHeader'
import { DataSearch } from './components/DataSearch'
import { Jaqi } from './components/Jaqi'
import { Liveboard } from './components/Liveboard'
import { useInitializeThoughtSpot } from './hooks/useInitializeThoughtSpot'
import { PAGES, PATH } from './interfaces'

export default function Dashboard() {
  const { path } = useRouteMatch()
  const selectedPage = PAGES.find((page) => page.path === path)
  const userId = useAppSelector((state) => state.authStates.user_id)

  useInitializeThoughtSpot(userId)

  return (
    <>
      <DashboardHeader />
      {selectedPage?.path === PATH.Dashboard && <Liveboard />}
      {selectedPage?.path === PATH.Campaigns && <Campaigns />}
      {selectedPage?.path === PATH.DataSearch && <DataSearch />}
      {selectedPage?.path === PATH.JaqiAi && <Jaqi />}
    </>
  )
}
